const ROOT = 'highnote'

const topupConfigRoot = [ROOT, 'topup', 'config'] as const

export const highnoteKeys = {
  topupConfigRoot,
  topupConfig: () => [...topupConfigRoot] as const,
}
